import Button from '../button';
import React from 'react';
import { MathUtils } from 'three';
import { useTexture } from '../../../hooks';
const { degToRad } = MathUtils;

const CustomSpotItem = ({ spot, onSelect }: any)=>{
  const { texture: btnSpotTxt } = useTexture(spot.icon_url);

  return <group key={spot.id} rotation={[degToRad(-spot.atv), degToRad(-spot.ath), 0, 'YXZ']}>
    <Button
      position={[0, 0, -1.5]}
      defaultState={{
        main: {
          size: (0.22 * spot.spot_size_percentage/100),
          material: {
            transparent: true,
            map: btnSpotTxt
          },
        },
      }}
      onClick={() => onSelect(spot)}
    />
  </group>
};

export default CustomSpotItem;
